import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Affix,
  Button,
  Card as Card1,
  Checkbox,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Tag,
  Upload,
  message
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { createRef, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";
import { H5, H6 } from "../../../../AbstractElements";
import {
  EstimateApi,
  GSTAPI,
  ProjectAddressApi,
  ProjectApi,
  ProjectFileApi,
} from "../../../../api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { getResultBySearch } from "../../../../api/product.api";
import { LoggerContext } from "../../../../context/logging";
import { useCallbackPrompt } from "../../../../utils/Hooks/useCallbackPrompt";
import { poCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import { DocumentUpload } from "../Po/document-upload";
import PaymentTerms from "../Po/paymentTerms";
import RateContracts from "../RateContracts";
import "./Quote.style.css";
import AdditionalCharges from "./additionalCharges";
import CSVReader from "./csvReader";
import DeliveryDrawer from "./deliveryDrawer";
import EditableItemTable from "./editableItemTable";
import { QuotePreview } from "./preview";
import TaxAmount from "./taxAmount";
import TermsAndConditions from "./termsAndConditions";
import XLSXReader from "./xlsxReader";
// import TermsAndConditions from "../Po/termsAndConditions";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const poOptions = [
  {
    id: 4,
    label: "Estimate",
    value: "estimate",
  },
];

const statusOptions = [
  { id: "1", value: "draft", label: "Draft" },
  {
    id: "2",
    value: "pricing_and_availability_check",
    label: "Pricing and Availability Check",
  },
  {
    id: "3",
    value: "availability_check",
    label: "Availability Check",
  },
  {
    id: "4",
    value: "quote_approval_pending",
    label: "Quote Approval pending",
  },
  {
    id: "5",
    value: "quotation_approved",
    label: "Quotation Approved - Initiate Delivery",
  },
  {
    id: "6",
    value: "order_lost",
    label: "Order Lost",
  },
  {
    id: "7",
    value: "vendor_po_raised",
    label: "Vendor Po Raised",
  },
  {
    id: "8",
    value: "dispatched",
    label: "Dispatched",
  },
  {
    id: "9",
    value: "delivered",
    label: "Delivered",
  },
];

const EstimateForm = (props) => {
  const poFormRef = useRef();
  const [products, setProducts] = useState([]);

  const logger = React.useContext(LoggerContext);
  const defaultTaxes = [
    {
      id: 1,
      label: "None",
      value: "none",
      tax_value: 0,
    },
    {
      id: 6,
      label: "5% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 5,
    },
    {
      id: 7,
      label: "12% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 12,
    },
    {
      id: 8,
      label: "18% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 18,
    },
    {
      id: 9,
      label: "28% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 28,
    },
    {
      id: 2,
      label: "5% IGST",
      value: "igst",
      tax_value: 5,
    },
    {
      id: 3,
      label: "12% IGST",
      value: "igst",
      tax_value: 12,
    },
    {
      id: 4,
      label: "18% IGST",
      value: "igst",
      tax_value: 18,
    },
    {
      id: 5,
      label: "28% IGST",
      value: "igst",
      tax_value: 28,
    },
  ];
  const attatchmentFormRef = useRef();
  const { Option } = Select;
  const history = useNavigate();
  const { estimate_id } = useParams();
  const location = useLocation();
  const { user } = props.settings;
  const [organisationDetails, setOrganisationDetails] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [fileInput, setFileInput] = useState(null);
  const [search, setSearch] = useState(null);
  const [imageEstimateChecked, setImageEstimateChecked] = useState(true);
  const [initialEstimateStatus, setInitialEstimateStatus] = useState("draft");
  const [poDetails, setPoDetails] = useState(null);
  const [gst, setGst] = useState([]);
  const [projectAddress, setProjectAddress] = useState([]);
  const [additionalCharges, setAdditionalCharges] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [fileType, setFileType] = useState("csv");
  const [paymentTerms, setPaymentTerms] = useState([
    {
      term: "Payment in Advance",
      percentage: 100,
      deadline: moment().format("YYYY-MM-DD"),
      total: 100,
    },
  ]);
  const [projectDetails, setProjectDetails] = useState();
  const [final_discount_amount, setFinalDiscountAmount] = useState(0);
  const [defaultPaymentTerms, setDefaultPaymentTerms] = useState([]);
  const [defaultAdditionalCharges, setDefaultAdditionalCharges] = useState([]);
  const [shippingAddressVisible, setShippingAddressVisible] = useState(false);
  const [billingAddressVisible, setBillingAddressVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileUploading, setFileUploading] = useState(false);
  const [showProductSearchDrawer, setShowProductSearchDrawer] = useState(false);

  const [shipToDisplayAddress, setShipToDisplayAddress] = useState(null);
  const [billToDisplayAddress, setBillToDisplayAddress] = useState(null);

  const [visibleAddress, setVisibleAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentModalVisible, setDocumentModalVisible] = useState(false);
  const [startedEditing, setStartedEditing] = useState(true);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(startedEditing);

  const [missingFields, setMissingFields] = useState([]);

  const [deliveryPOCDrawerVisible, setDeliveryPOCDrawerVisible] =
    useState(false);
  const [toSendData, setToSendData] = useState(null);

  const formRefAddress = useRef();
  const showDrawerAddress = () => {
    setVisibleAddress(true);
  };

  const onCloseAddress = () => {
    formRefAddress.current.resetFields();
    setVisibleAddress(false);
  };

  const [newAddress, setNewAddress] = useState({
    label: "",
    city: "",
    pincode: "",
    address: "",
  });

  const [currentGst, setCurrentGst] = useState(null);
  const [finalValue, setFinalValue] = useState({
    estimate_status: "",
    organisation: user?.organisation?.organisation_id,
    project: props.settings?.project?.id,
    terms_and_condition: "",
    terms_and_conditions_description: "",
    gst: "",
    bill_address: null,
    bill_address_description: "",
    ship_address: null,
    ship_address_description: "",
    documents: [],
  });
  const [deliveryDetails, setDeliveryDetails] = useState({
    delivery_poc: null,
    delivery_location: null,
    expected_delivery_time: null,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    getOrganisationDetails();
    fetchProjectDetails();
    fetchGst({ organisation: user?.organisation?.organisation_id });
    fetchAddress({ project: props.settings?.project?.id });
    if (location?.state?.editId) {
      fetchEstimateDetails(location?.state?.editId);
    } else {
    }
  }, []);

  const fetchEstimateDetails = (id) => {
    axios.get(`${EstimateApi}?id=${id}`).then((res) => {
      var estimateDetails = res.data?.results[0];
      setPoDetails(estimateDetails);
      poFormRef?.current?.setFieldsValue({
        gst: estimateDetails?.gst?.id,
        address: estimateDetails?.address?.id,
      });
      if (estimateDetails?.bill_address) {
        setBillingAddressVisible(true);
      }
      if (estimateDetails?.ship_address) {
        setShippingAddressVisible(true);
      }
      setBillToDisplayAddress(estimateDetails?.bill_address);
      setShipToDisplayAddress(estimateDetails?.ship_address);
      setFinalValue({
        organisation: estimateDetails?.organisation,
        project: estimateDetails?.project.id,
        terms_and_condition: estimateDetails?.terms_and_condition?.id,
        total_estimate_amount: estimateDetails?.total_estimate_amount,
        terms_and_conditions_description:
          estimateDetails?.terms_and_conditions_description,
        gst: estimateDetails?.gst?.id,
        documents: estimateDetails?.documents,
        bill_address: estimateDetails?.bill_address?.id,
        ship_address: estimateDetails?.ship_address?.id,
        estimate_status: estimateDetails?.estimate_status,
      });
      setDeliveryDetails({
        delivery_poc: estimateDetails?.delivery_poc,
        delivery_location: estimateDetails?.delivery_location,
        expected_delivery_time: estimateDetails?.expected_delivery_time,
      });
      setInitialEstimateStatus(estimateDetails?.estimate_status ?? "draft");
      setFileList(estimateDetails?.documents);

      setDefaultPaymentTerms(estimateDetails?.estimate_payment_terms);
      setPaymentTerms(estimateDetails?.estimate_payment_terms);
      var addArr = estimateDetails?.estimate_additional_charges ?? [];
      if (addArr?.length === 0) {
        setDefaultAdditionalCharges([]);
      } else {
        for (var i = 0; i < addArr?.length; i++) {
          addArr[i].total =
            addArr[i].amount + addArr[i].amount * addArr[i].tax_value * 0.01;
        }
        console.log(addArr[i], "addArr");
        setDefaultAdditionalCharges(addArr);
      }
      var items = estimateDetails?.estimate_items;

      const allItems = [...items];
      allItems?.map((item) => {
        let gross_margin = 0;
        if (!isNaN(item.margin)) {
          gross_margin = item.margin / (1 + item.margin / 100);
        } else {
          gross_margin = "";
        }
        if (item.product_handle?.length > 0) {
          item.disabled = true;
        }
        item.gross_margin = gross_margin;
      });
      console.log("items", items);
      setDataSource([...allItems]);
    });
  };
  useEffect(() => {
    let fieldsValue = poFormRef.current?.getFieldsValue();
    if (fieldsValue) {
      poFormRef?.current?.setFieldsValue(fieldsValue);
      setFinalValue({ ...finalValue });
    }
  }, [additionalCharges]);

  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };

  const fetchProjectDetails = () => {
    axios.get(`${ProjectApi}${props.settings?.project?.id}/`).then((res) => {
      setProjectDetails(res.data);
    });
  };

  const fetchGst = (params = {}) => {
    axios.get(`${GSTAPI}`, { params: { ...params } }).then((res) => {
      setGst(res.data);
    });
  };

  useEffect(() => {
    setGstInFinalValue();
  }, [gst, dataSource]);

  const checkIfAllValuesArePresent = (formData, isDraft) => {
    if (isDraft && (!formData.boq_item || formData.boq_item == "")) {
      return false;
    }
    if (
      !isDraft &&
      (!formData.boq_item ||
        formData.boq_item == "" ||
        formData.quantity == "" ||
        !formData.quantity ||
        formData.unit == "" ||
        !formData.unit ||
        formData.brand == "" ||
        !formData.brand ||
        formData.tax_value == "" ||
        !formData.tax_value ||
        formData.unit_selling_price == "" ||
        !formData.unit_selling_price)
    ) {
      return false;
    }
    return true;
  };

  const setGstInFinalValue = () => {
    console.log("setGstInFinalValue");
    setTimeout(() => {
      if (gst?.length > 0 && !location.pathname.includes("edit")) {
        let values = poFormRef?.current?.getFieldsValue();
        values = {
          ...values,
          gst: gst[0].id,
        };
        poFormRef?.current?.setFieldsValue(values);
        setFinalValue({
          ...finalValue,
          gst: gst[0].id,
        });
        setCurrentGst({ ...gst[0] });
      } else if (gst?.length > 0 && poDetails?.gst?.id) {
        let values = poFormRef?.current?.getFieldsValue();
        const current = gst?.find((item) => item?.id == poDetails?.gst?.id);
        console.log("current", current, poDetails?.gst?.id, gst);
        setCurrentGst({ ...current });
        values = {
          ...values,
          gst: current.id,
        };
        poFormRef?.current?.setFieldsValue(values);
      }
    }, 500);
  };
  const fetchAddress = (params = {}) => {
    axios.get(`${ProjectAddressApi}`, { params: { ...params } }).then((res) => {
      setProjectAddress(res.data);
      setGstInFinalValue();
      if (!location.pathname.includes("edit")) {
        // setFinalValue({
        //   ...finalValue,
        //   bill_address: res.data[0]?.id,
        //   ship_address: res.data[0]?.id,
        // });
        // setShipToDisplayAddress(res.data[0]);
        // setBillToDisplayAddress(res.data[0]);
      }
    });
  };

  const getMissingFields = (fields) => {
    const missingFields = [];
    console.log("debug>>> fields,", fields);
    if (!fields.boq_item) {
      missingFields.push("boq_item");
    }
    if (!fields.quantity) {
      missingFields.push("quantity");
    }
    if (!fields.unit) {
      missingFields.push("unit");
    }
    if (!fields.brand) {
      missingFields.push("brand");
    }
    if (!fields.category_name || fields?.category_name == "") {
      missingFields.push("category");
    }
    if (!fields.tax_value) {
      missingFields.push("tax_value");
    }
    if (!fields.unit_selling_price) {
      missingFields.push("unit_selling_price");
    }

    return missingFields;
  };

  const createEstimate = ({ isDraft = false }) => {
    if (
      !(
        projectDetails?.contact_phone &&
        projectDetails?.contact_phone?.toString().length > 0
      )
    ) {
      message.info(
        "Please enter contact in project settings to make pro forma invoice",
        3
      );
      return;
    }
    let requiredDetailsFilled = true;
    const newValue = finalValue;
    if (imageEstimateChecked) {
      newValue.image = true;
    }
    if (isDraft) {
      newValue.is_draft = true;
    }
    // logger.log(LogEvents.sendPO, {});
    setLoading(true);
    setMissingFields([]);
    console.log(newValue);
    // if (displayAddress?.address === "") {
    //   toast.error("Please select address");
    //   setLoading(false);

    //   return;
    // }

    if (newValue.project) {
      if (dataSource.length < 1) {
        toast.error("Enter at least one item!");
        setLoading(false);

        return;
      }
      const full_percentage = paymentTerms?.reduce((acc, obj) => {
        return acc + obj.percentage;
      }, 0);
      if (full_percentage !== 100) {
        toast.error("Total Percentage for terms should be 100!");
        setLoading(false);
        return;
      }

      var totalAdditonalCharges = additionalCharges?.reduce((acc, obj) => {
        return acc + obj.total;
      }, 0);
      newValue.total_estimate_amount = (
        getTotalAmount() + totalAdditonalCharges
      ).toFixed(2);
      var arr = dataSource;
      var newArr = [];
      for (var i = 0; i < arr?.length; i++) {
        var data = arr[i];
        console.log(arr[i], "arr[i]");
        const formData = {
          boq_item: data.boq_item,
          quantity: data.quantity,
          unit: data.unit,
          hsn_code: data.hsn_code,
          brand: data.brand,
          unit_selling_price: data.unit_selling_price,
          margin: data.margin,
          tax_value: data.tax_value,
          tax_type: data.tax_type,
          mrp: data.mrp,
          item_image: data.item_image,
          product_handle: data.product_handle,
          variant_handle: data.variant_handle,
          category_name: data.category_name,
          landing_price: data.landing_price,
          item_description: "",
        };
        if (location.pathname.includes("edit")) {
          formData.id = data.id;
        }

        const currentFilled = checkIfAllValuesArePresent(formData);
        if (!currentFilled) {
          const currentMissingFields = getMissingFields(formData);
          console.log("debug>>> missing", currentMissingFields, "i", i);
          setMissingFields([
            ...missingFields,
            {
              index: i,
              missingFields: currentMissingFields,
            },
          ]);
        }
        requiredDetailsFilled = currentFilled;
        requiredDetailsFilled = checkIfAllValuesArePresent(formData, isDraft);

        newArr.push(formData);
      }
      if (!requiredDetailsFilled) {
        message.error(
          "Please fill all the required details of estimate items."
        );
        setLoading(false);

        return;
      }
      newValue.estimate_items = newArr;
      newValue.gst = currentGst?.id;
      newValue.estimate_additionals = additionalCharges;
      newValue.final_discount_amount = Number(
        final_discount_amount != "" ? final_discount_amount : 0
      );
      newValue.documents = newValue.documents?.map((doc) => doc.id);
      if (location.pathname.includes("edit")) {
        newValue.estimate_id = estimate_id ?? location.state.editId;
      }
      var arr1 = [];
      for (var i = 0; i < paymentTerms.length; i++) {
        let paymentTermTemp = paymentTerms[i];
        console.log("PO payment 1", paymentTermTemp);
        if (paymentTermTemp?.deadline) {
          console.log("PO payment 2", paymentTermTemp);
          paymentTermTemp.deadline = moment(paymentTerms[i]?.deadline).format(
            "YYYY-MM-DD"
          );
        } else {
          delete paymentTermTemp.deadline;
        }
        if (paymentTermTemp?.percentage > 0) arr1.push(paymentTermTemp);
      }
      console.log("PO payment final 3", arr1);
      newValue.estimate_payment_terms = arr1;
      const selectedAddress = projectAddress?.find(
        (address) => address?.id == billToDisplayAddress?.id
      );
      newValue.address = selectedAddress?.id;
      if (billToDisplayAddress) {
        newValue.bill_address_description =
          billToDisplayAddress?.address +
          ", " +
          billToDisplayAddress?.city +
          ", " +
          billToDisplayAddress?.pincode;
      }
      if (shipToDisplayAddress) {
        newValue.ship_address_description =
          shipToDisplayAddress?.address +
          ", " +
          shipToDisplayAddress?.city +
          ", " +
          shipToDisplayAddress?.pincode;
      }

      // Check if the estimate status is quotation_approved_payment_pending
      // or indexes higher than that. If yes, then save the value in a state var
      // and display the popup for delivery details.
      // Do not display the drawer if the delivery details are already present

      if (
        statusOptions.findIndex(
          (x) => x.value === finalValue.estimate_status
        ) >= statusOptions.findIndex((x) => x.value === "quotation_approved") &&
        (!deliveryDetails.delivery_poc ||
          !deliveryDetails.delivery_location ||
          !deliveryDetails.expected_delivery_time) &&
        finalValue.estimate_status !== "order_lost"
      ) {
        setToSendData(newValue);
        setDeliveryPOCDrawerVisible(true);
        setLoading(false);
        return;
      }

      axios
        .post(`${EstimateApi}`, newValue)
        .then((res) => {
          return setStartedEditing(false);
        })
        .then(() => {
          history(`/app/project/estimates/`, {
            state: { id: props.settings?.project?.id },
          });
          toast.success("Estimate created successfully!");
          setLoading(false);
        })
        .catch(() => {
          toast.error("Something went wrong!");
          setLoading(false);
        });
    } else {
      toast.error("Enter all fields!");
      setLoading(false);
    }
  };

  const onDeliveryFinish = (values) => {
    const payload = {
      ...toSendData,
      ...values,
    };
    axios
      .post(`${EstimateApi}`, payload)
      .then((res) => {
        return setStartedEditing(false);
      })
      .then(() => {
        history(`/app/project/estimates/`, {
          state: { id: props.settings?.project?.id },
        });
        toast.success("Estimate created successfully!");
        setLoading(false);
      })
      .catch(() => {
        toast.error("Something went wrong!");
        setLoading(false);
      });
  };

  const getFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["B", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(parseFloat(bytes / Math.pow(k, i))) + " " + sizes[i];
  };

  const onDocumentAdd = async (file) => {
    try {
      setFileUploading(true);
      const result = await Promise.all(
        Object.keys(file).map((key) => {
          console.log("KK", key, file[key]);
          const formData = new FormData();
          formData.append("file", file[key], file[key].name);
          formData.append("file_name", file[key].name);
          formData.append("project", props.settings?.project?.id);
          formData.append("file_size", getFileSize(file[key]?.size));
          return axios
            .post(ProjectFileApi, formData)
            .then((res) => {
              let finalValueTemp = { ...finalValue };
              finalValueTemp.documents?.push({
                document: res?.data?.file,
                id: res?.data?.id,
                file_name: res?.data?.file_name,
              });
              setFileList([...finalValueTemp.documents]);
              setFinalValue({ ...finalValueTemp });
              toast.success("Files Upload Successfully !");
            })
            .catch((e) => {
              console.log("e", { e });
              toast.error("Something went wrong!");
            });
        })
      );

      // if (Array.isArray(file)) {
      //   const result = await Promise.all(
      //     file.map(async (file) => uploadDocument(file))
      //   );
      //   setFileList([...fileList, ...result]);
      //   setFinalValue({
      //     ...finalValue,
      //     documents: [...finalValue.documents, ...result],
      //   })
      // } else {
      //   const result = await uploadDocument(file);
      //   setFileList([...fileList, result]);
      //   setFinalValue({
      //     ...finalValue,
      //     documents: [...finalValue.documents, result],
      //   });
      // }
    } catch (e) {
      console.log("i-log> ", e);
    } finally {
      setFileUploading(false);
    }
  };

  const onDocumentRemove = (file) => {
    const id = file.id;
    console.log(
      "i-log> files",
      fileList,
      fileList.filter((file) => file.id !== id)
    );
    setFileList(fileList.filter((file) => file.id !== id));
    setFinalValue({
      ...finalValue,
      documents: finalValue.documents.filter((file) => file.id !== id),
    });
  };

  const handleTermsandConditions = ({
    id,
    terms_and_conditions_description,
  }) => {
    console.log("handleTermsandContions", id);
    setFinalValue({
      ...finalValue,
      terms_and_condition: id,
      terms_and_conditions_description: terms_and_conditions_description,
    });
  };

  const handleTermsandConditionsDesc = (value) => {
    console.log("handleTermsandContions", value);

    setFinalValue({
      ...finalValue,
      terms_and_conditions_description: value,
    });
  };

  const addNewAddress = () => {
    const updatedValues = formRefAddress.current.getFieldsValue();
    const values = new FormData();
    values.append("label", updatedValues.label);
    values.append("city", updatedValues.city);
    values.append("pincode", updatedValues.pincode);
    values.append("address", updatedValues.address);
    values.append("project", props.settings?.project?.id);
    values.append("contact_person", updatedValues.contact_person);
    values.append("contact_phone", updatedValues.contact_phone);
    values.append("contact_email", updatedValues.contact_email);
    values.append("google_map_address", updatedValues.google_map_address);
    values.append("gst_no", updatedValues.gst_no);
    values.append("pan_no", updatedValues.pan_no);

    axios
      .post(`${ProjectAddressApi}`, values)
      .then((res) => {
        toast.success("Successfully added address!");
        fetchAddress({ project: props.settings?.project?.id });
        onCloseAddress();
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  const getTotalTaxableAmount = () => {
    let amount = 0;
    dataSource?.forEach((item) => {
      amount +=
        parseFloat(
          parseFloat(item?.unit_selling_price, 2) +
            (parseFloat(item?.unit_selling_price, 2) *
              parseFloat(item?.margin, 2)) /
              100
        ) * parseFloat(item?.quantity);
    });
    return amount;
  };

  const setTaxForAllItems = (tax_id) => {
    const tax_selected = defaultTaxes.find((tax) => tax.id == tax_id);
    const allItems = [...dataSource];
    allItems?.map((item) => {
      item.tax_type = tax_selected?.value;
      item.tax_value = tax_selected?.tax_value;
    });
    console.log("allItems", allItems);
    setDataSource(allItems);
  };

  const setMarginForAllItems = (gross_margin) => {
    const allItems = [...dataSource];
    allItems?.map((item) => {
      item.gross_margin = gross_margin;
      item.margin = gross_margin / (1 - gross_margin / 100);
    });
    console.log("allItems", allItems);
    setDataSource(allItems);
  };

  const getTotalAmount = () => {
    let amount = 0;
    dataSource?.map((item) => {
      amount +=
        parseFloat(item?.quantity, 2) *
        ((parseFloat(item?.unit_selling_price, 2) +
          parseFloat(item?.unit_selling_price, 2) *
            (parseFloat(item?.margin, 2) / 100)) *
          ((parseFloat(item?.tax_value, 2) + 100) / 100));
    });
    amount -= parseFloat(final_discount_amount);
    return amount;
  };

  const totalAdditonalCharge = additionalCharges?.reduce((acc, obj) => {
    return acc + obj.total ?? 0;
  }, 0);
  const ref = createRef();
  const formRef = createRef();

  const handleAdd = () => {
    const newData = {
      id: dataSource.length + 1,
      boq_item: `Item ${dataSource.length + 1}`,
      hsn_code: "",
      category_name: "",
      brand: ``,
      mrp: "0",
      unit_selling_price: "0",
      md_price_gst: "0",
      image: null,
      quantity: "1",
      unit: "sqft",
      margin: 0,
      gross_margin: 0,
      tax_value: "18",
      tax_type: "cgst_sgst",
    };
    setDataSource([...dataSource, newData]);
  };

  const getPreview = ({
    currentGst,
    dataSource,
    additionalCharges,
    totalAdditonalCharge,
    billToDisplayAddress,
    shipToDisplayAddress,
    createEstimate,
    terms_and_conditions_description,
  }) => {
    return (
      <QuotePreview
        projectDetails={projectDetails}
        user={user}
        currentGst={currentGst}
        billTo={billToDisplayAddress}
        shipTo={shipToDisplayAddress}
        terms={terms_and_conditions_description}
        dataSource={dataSource}
        branch={props?.settings?.branch}
        additionalCharges={additionalCharges}
        totalAdditonalCharge={totalAdditonalCharge}
        organisationDetails={organisationDetails}
        createEstimate={createEstimate}
        paymentTerms={paymentTerms}
      />
    );
  };

  const showShippingAddressSection = () => {
    setShippingAddressVisible(true);
    if (projectAddress?.length > 0) {
      // setShipToDisplayAddress(projectAddress[0]);
    }
  };

  const showBillingAddressSection = () => {
    setBillingAddressVisible(true);
    if (projectAddress?.length > 0) {
      // setBillToDisplayAddress(projectAddress[0]);
    }
  };

  const removeShippingAddress = () => {
    setShippingAddressVisible(false);
    setShipToDisplayAddress(null);
    setFinalValue({
      ...finalValue,
      ship_address: null,
    });
  };

  const removeBillingAddress = () => {
    setBillingAddressVisible(false);
    setBillToDisplayAddress(null);
    setFinalValue({
      ...finalValue,
      bill_address: null,
    });
  };

  const onSearch = (e) => {
    if (e.length > 0) {
      console.log("onSearch", e);
      setSearch(e);
      getResultBySearch(e).then((data) => {
        setProducts(data);
      });
    }
  };

  const onProductSelect = ({ e, builtProduct = null }) => {
    const product =
      builtProduct !== null
        ? builtProduct
        : products.find((item) => item.product_name === e);

    var gross_margin = 0;
    var margin = 0;
    if (product.md_price_gst_studio && product.md_price_gst_studio > 0) {
      gross_margin =
        ((parseFloat(product.md_price_gst_studio ?? 0) -
          parseFloat(product.md_price_gst_msp ?? 0)) /
          parseFloat(product.md_price_gst_studio ?? 1)) *
        100;
      margin = gross_margin / (1 - gross_margin / 100);
    }

    const newData = {
      id: dataSource.length + 1,
      boq_item: product?.product_name,
      hsn_code: product?.sku,
      brand: product?.brand?.brand_name,
      unit_selling_price: parseFloat(
        product?.md_price_gst_msp /
          (parseFloat(product.gst) ? parseFloat(product.gst) / 100 + 1 : 1.18)
      ).toFixed(2),
      quantity: "1",
      unit: product?.price_unit,
      margin: margin,
      gross_margin: gross_margin,
      tax_value: "18",
      tax_type: "cgst_sgst",
      mrp: product?.mrp,
      disabled: true,
      md_price_gst: product?.md_price_gst_msp,
      product_handle: product.product_handle,
      variant_handle: product.variant_handle,
      category_name: product.category?.category_name,
      item_description: "",
      landing_price: parseFloat(
        parseFloat(product.md_price_gst) /
          (parseFloat(product.gst) ? parseFloat(product.gst) / 100 + 1 : 1.18)
      ).toFixed(2),
      item_image: product?.variant_image[0]?.image_url ?? null,
    };
    setDataSource([...dataSource, newData]);
    console.log("count", dataSource.length + 1);
    setSearch(null);
  };

  const handleSearch = () => {
    setShowProductSearchDrawer(true);
  };

  const customProductAdd = (product, remove = false) => {
    if (remove) {
      const allItems = [...dataSource];
      const index = allItems.findIndex(
        (item) => item.boq_item === product.product_name
      );
      allItems.splice(index, 1);
      setDataSource(allItems);
    } else {
      onProductSelect({ e: null, builtProduct: product });
    }
  };

  const getProductName = (product) => {
    return (
      product.product_name +
      " (" +
      product.brand?.brand_name +
      ", Rs." +
      (product.md_price_gst && product.md_price_gst != ""
        ? product.md_price_gst
        : 0) +
      ")"
    );
  };

  return (
    <div>
      <Modal
        title="Confirm leaving the page?"
        visible={showPrompt}
        onOk={async () => {
          cancelNavigation();
          setLoading(true);
          createEstimate({ isDraft: true });
          // setLoading(false);
          // confirmNavigation();
        }}
        onCancel={() => {
          confirmNavigation();
        }}
        okText="Save as draft"
        cancelText="Leave without saving"
      >
        <p style={{ margin: "0 1rem" }}>Unsaved changes might be lost.</p>
      </Modal>
      <Container fluid={true}>
        <Spin spinning={loading} size="large" style={{ position: "fixed" }}>
          <Card ref={ref}>
            <CardBody>
              <Form ref={poFormRef} id="poForm">
                {/* Main Details */}
                <Row gutter={24}>
                  <Col sm={12}>
                    <img
                      src={organisationDetails?.organisation_logo}
                      style={{ height: "80px" }}
                    />

                    <Card1 className="mt-3">
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          Address
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>{currentGst?.address}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          PIN Code
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>{currentGst?.pincode}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          GST Number
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>{currentGst?.gst_no}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="my-3">
                        <Col sm={5} md={5}>
                          Select Address
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:{}</Col>
                            <Col sm={11}>
                              <Form.Item
                              // name="gst"
                              // rules={[
                              //   {
                              //     required: true,
                              //     message: "GST is required",
                              //   },
                              // ]}
                              >
                                <Select
                                  value={finalValue?.gst}
                                  onChange={(e) => {
                                    setFinalValue({
                                      ...finalValue,
                                      gst: e,
                                    });
                                    console.log(
                                      gst.find((item) => item.id === e)
                                    );
                                    setCurrentGst(
                                      gst.find((item) => item.id == e)
                                    );
                                  }}
                                  key={"select_gst"}
                                  placeholder="GST"
                                  className="w-100"
                                >
                                  {gst?.map((each) => (
                                    <Option key={each.id} value={each.id}>
                                      {each?.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card1>
                  </Col>
                  <Col sm={12} className="quote-details-section">
                    <Card1 className="mt-3">
                      <Row gutter={16}>
                        <Col sm={5} md={5}>
                          Created By
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={22}>
                              {" " +
                                user?.name +
                                " (" +
                                user?.contact +
                                ", " +
                                user?.email +
                                ")"}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          Client
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={22}>
                              {" " + projectDetails?.project_name}
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          Bank Details
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={22}>
                              Account Number (
                              {props?.settings?.branch?.bank_account_number})
                              <br />
                              IFSC Code ({props?.settings?.branch?.bank_ifsc})
                              <br />
                              UPI ({props?.settings?.branch?.branch_upi})
                              <br />
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          Status
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={16}>
                              <Form.Item
                                // name="estimate_status"
                                rules={[
                                  {
                                    required: true,
                                    message: "Order Type is required",
                                  },
                                ]}
                              >
                                <Select
                                  className="w-100"
                                  key={"estimate_status"}
                                  value={finalValue?.estimate_status}
                                  onChange={(e) => {
                                    setFinalValue({
                                      ...finalValue,
                                      estimate_status: e,
                                    });
                                  }}
                                >
                                  {statusOptions?.map((each, index) => (
                                    <Option
                                      // disabled={
                                      //   index <
                                      //   statusOptions.findIndex(
                                      //     (status) =>
                                      //       status.value ===
                                      //       initialEstimateStatus
                                      //   )
                                      // }
                                      value={each?.value}
                                      key={each?.id}
                                    >
                                      {each?.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card1>
                    {/* <Row gutter={16} className="mt-3">
                      <Col sm={5} md={5}>
                        Delivery Date
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}>
                            <Form.Item
                              name="delivery_date"
                              rules={[
                                {
                                  required: true,
                                  message: "Delivery Date is required",
                                },
                              ]}
                            >
                              <DatePicker
                                value={moment(finalValue.delivery_date)}
                                allowClear={false}
                                defaultValue={moment(finalValue?.delivery_date)}
                                onChange={(e) => {
                                  setFinalValue({
                                    ...finalValue,
                                    delivery_date:
                                      moment(e).format("YYYY-MM-DD"),
                                  });
                                }}
                                className="w-100"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>
                {/* Bill To */}
                <Row gutter={24} className="mt-3">
                  <Col sm={12}>
                    <Card1 key="bill_to">
                      {!billingAddressVisible ? (
                        <>
                          <Row justify="center">
                            <Tag
                              style={{ cursor: "pointer" }}
                              color="blue"
                              onClick={showBillingAddressSection}
                            >
                              Click here to add Billing address
                            </Tag>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row justify="space-between">
                            <H6>Bill To</H6>
                            <div>
                              <Tag
                                style={{ cursor: "pointer" }}
                                onClick={removeBillingAddress}
                              >
                                Remove
                              </Tag>
                            </div>
                          </Row>
                          <Row gutter={16} className="mt-3">
                            <Col sm={4} md={4}>
                              Name
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {billToDisplayAddress?.label ?? ""}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={16} className="mt-3">
                            <Col sm={4} md={4}>
                              Address
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {/* <Form.Item name="bill_address"> */}
                                  <Select
                                    className="w-100"
                                    key={"bill_address_select"}
                                    value={finalValue?.bill_address}
                                    optionFilterProp="children"
                                    placeholder={"Address"}
                                    onChange={(e) => {
                                      setFinalValue({
                                        ...finalValue,
                                        bill_address: e,
                                      });
                                      setBillToDisplayAddress(
                                        projectAddress.find(
                                          (addr) => addr.id === e
                                        )
                                      );
                                    }}
                                  >
                                    {projectAddress?.map((each) => {
                                      return (
                                        <Option key={each.id} value={each.id}>
                                          {each?.label}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                  {/* </Form.Item> */}
                                </Col>
                                <Col>
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                      showDrawerAddress();
                                    }}
                                  >
                                    Add New Address
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row gutter={16} className="mt-2">
                            <Col sm={4} md={4}>
                              Contact person
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {billToDisplayAddress?.contact_person}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col sm={4} md={4}>
                              Contact number
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {billToDisplayAddress?.contact_phone}
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row gutter={16} className="mt-1">
                            <Col sm={20} md={20}>
                              {billToDisplayAddress && (
                                <Row className="mt-1">
                                  Selected address:{" "}
                                  {billToDisplayAddress?.address},{" "}
                                  {billToDisplayAddress?.city}{" "}
                                  {billToDisplayAddress?.pincode}
                                </Row>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}
                    </Card1>
                  </Col>
                  <Col sm={12}>
                    <Card1 key="ship_to">
                      {!shippingAddressVisible ? (
                        <>
                          <Row justify="center">
                            <Tag
                              style={{ cursor: "pointer" }}
                              color="blue"
                              onClick={showShippingAddressSection}
                            >
                              Click here to add Shipping address
                            </Tag>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row justify="space-between">
                            <H6>Ship To</H6>
                            <div>
                              <Tag
                                style={{ cursor: "pointer" }}
                                onClick={removeShippingAddress}
                              >
                                Remove
                              </Tag>
                            </div>
                          </Row>
                          <Row gutter={16} className="mt-3">
                            <Col sm={4} md={4}>
                              Name
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {shipToDisplayAddress?.label ?? ""}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={16} className="mt-3">
                            <Col sm={4} md={4}>
                              Address
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {/* <Form.Item name="ship_address"> */}
                                  <Select
                                    className="w-100"
                                    key={"ship_address_select"}
                                    value={finalValue?.ship_address}
                                    optionFilterProp="children"
                                    placeholder={"Address"}
                                    onChange={(e) => {
                                      console.log(" e ", e);
                                      setFinalValue({
                                        ...finalValue,
                                        ship_address: e,
                                      });
                                      setShipToDisplayAddress(
                                        projectAddress.find(
                                          (addr) => addr.id === e
                                        )
                                      );
                                    }}
                                  >
                                    {projectAddress?.map((each) => {
                                      return (
                                        <Option key={each.id} value={each.id}>
                                          {each?.label}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                  {/* </Form.Item> */}
                                </Col>
                                <Col>
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                      showDrawerAddress();
                                    }}
                                  >
                                    Add New Address
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row gutter={16} className="mt-2">
                            <Col sm={4} md={4}>
                              Contact person
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {shipToDisplayAddress?.contact_person}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col sm={4} md={4}>
                              Contact number
                            </Col>
                            <Col sm={20} md={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {shipToDisplayAddress?.contact_phone}
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row gutter={16} className="mt-1">
                            <Col sm={4}>Selected address: </Col>
                            <Col sm={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {shipToDisplayAddress?.address},{" "}
                                  {shipToDisplayAddress?.city}{" "}
                                  {shipToDisplayAddress?.pincode}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={16} className="mt-1">
                            <Col sm={4}>Google Map Address</Col>
                            <Col sm={20}>
                              <Row>
                                <Col sm={1}>:</Col>
                                <Col sm={11}>
                                  {
                                    shipToDisplayAddress?.google_map_address?.length > 50
                                    ? shipToDisplayAddress?.google_map_address?.substring(0, 50) + "..."
                                    : shipToDisplayAddress?.google_map_address
                                  }
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Card1>
                  </Col>
                </Row>
                {/* SHIP */}
                <Row justify="space-between" align="bottom" className="mt-3">
                  <Row
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "baseline",
                    }}
                  >
                    <Button onClick={handleAdd} type="primary" className="mr-2">
                      Add row
                    </Button>

                    <Button onClick={handleSearch} className="mr-2">
                      Rate Con. & Bulk Upload
                    </Button>

                    {/* <Select
                      showSearch={true}
                      value={search}
                      key="product-search"
                      placeholder="Search Product"
                      style={{ width: "45%" }}
                      defaultActiveFirstOption={false}
                      showArrow={false}
                      filterOption={false}
                      allowClear={true}
                      onSearch={onSearch}
                      onChange={(e) => onProductSelect({ e })}
                      options={products.map((d) => ({
                        value: d.product_name,
                        label: getProductName(d),
                      }))}
                    /> */}
                  </Row>
                  <Row gutter={16}>
                    <Col style={{ display: "flex", justifyContent: "end" }}>
                      <div style={{ width: 180 }}>
                        <div style={{ textAlign: "right" }}>
                          Set margin for all items
                        </div>
                        <Input
                          type="number"
                          onWheel={(event) => event.currentTarget.blur()}
                          onChange={(e) => {
                            setMarginForAllItems(e.target.value);
                          }}
                        />
                      </div>
                    </Col>
                    <Col style={{ display: "flex", justifyContent: "end" }}>
                      <div style={{ width: 180 }}>
                        <div style={{ textAlign: "right" }}>
                          Set tax for all items
                        </div>
                        <Select
                          size="medium"
                          style={{ textAlign: "right", width: "100%" }}
                          onChange={(value) => setTaxForAllItems(value)}
                          key="all_tax"
                        >
                          {defaultTaxes.map((tax) => (
                            <Select.Option
                              value={tax.id}
                              style={{ textAlign: "right" }}
                              key={tax.id}
                            >
                              {tax.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  </Row>
                </Row>
                <div className="mt-3">
                  {/* {true && (
                    <Card1>
                      <EditableTable
                        projectId={props.settings?.project?.id}
                        editId={editId}
                        selectedRowKeys={items.map((item) => item.id)}
                        taxTypes={taxTypes}
                        setDefaultTax={setDefaultTax}
                        defaultSelectedItems={items}
                        setItems={setItems}
                      />
                    </Card1>
                  )} */}
                  <Card1>
                    <EditableItemTable
                      dataSource={dataSource}
                      setDataSource={setDataSource}
                      products={products}
                      handleAdd={handleAdd}
                      project={props.settings?.project}
                      missingFields={missingFields}
                      user={props.settings?.user}
                    />

                    {/*<ItemTable
                      projectId={props.settings?.project?.id}
                      editId={editId}
                      selectedRowKeys={items.map((item) => item.id)}
                      taxTypes={taxTypes}
                      setDefaultTax={setDefaultTax}
                      defaultSelectedItems={items}
                      setItems={setItems}
                    />*/}
                  </Card1>
                </div>
                <Row gutter={24} className="mt-3">
                  <Col sm={12}>
                    <Card1>
                      <PaymentTerms
                        setPaymentTerms={setPaymentTerms}
                        defaultPaymentTerms={defaultPaymentTerms}
                        formList={[
                          {
                            term: "Payment in Advance",
                            percentage: 100,
                            deadline: moment().format("YYYY-MM-DD"),
                            total: 100,
                          },
                        ]}
                      />
                      <TermsAndConditions
                        handleTermsandConditionsDesc={
                          handleTermsandConditionsDesc
                        }
                        handleTermsandConditions={handleTermsandConditions}
                        defaultTC={finalValue?.terms_and_condition}
                        defaultTCDesc={
                          finalValue?.terms_and_conditions_description
                        }
                      />
                      <div className="">
                        <div>
                          <span
                            style={{ fontSize: "18px", fontWeight: "bolder" }}
                          >
                            Documents
                          </span>{" "}
                          {"(Total files size should be less than 25MB)"}
                        </div>
                        <div className="py-2">
                          <DocumentUpload
                            onDocumentAdd={onDocumentAdd}
                            onDocumentRemove={onDocumentRemove}
                            documents={fileList}
                            loading={fileUploading}
                          />
                        </div>
                      </div>
                    </Card1>
                  </Col>
                  <Col sm={12}>
                    <Card1>
                      <div className="d-flex justify-content-between">
                        <div className="">Taxable Amount</div>
                        <div className="">
                          ₹ {Number(getTotalTaxableAmount()).toFixed(2)}
                        </div>
                      </div>
                      <TaxAmount items={dataSource} />
                      <AdditionalCharges
                        taxTypes={taxTypes}
                        setAdditionalCharges={setAdditionalCharges}
                        defaultAdditionalCharges={defaultAdditionalCharges}
                      />
                      {/* <div className="d-flex justify-content-between">
                        <div className="">Final Discount</div>
                        <div className="d-flex align-items-center">
                          <div>-</div>
                          <Input
                            type="number"
                            value={final_discount_amount}
                            formatter={(value) => `₹ -${value}`}
                            parser={(value) => value.replace("₹", "")}
                            onChange={(e) => {
                              setFinalDiscountAmount(
                                e.target.value != "" ? e.target.value : 0
                              );
                            }}
                            placeholder="Amount"
                          />
                        </div>
                      </div> */}
                      <div className="my-2">
                        <hr />
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <H5>Total Amount (Rounded off)</H5>
                        <H5>
                          ₹{" "}
                          {(
                            Math.ceil(
                              Number(getTotalAmount() + totalAdditonalCharge) *
                                100
                            ) / 100
                          ).toFixed(2)}
                        </H5>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="mr-2">
                          Send Pro Forma Invoice with images
                        </div>
                        <Checkbox
                          checked={imageEstimateChecked}
                          onChange={(value) => {
                            console.log("setImageEstimateChecked", value);
                            setImageEstimateChecked(value.target.checked);
                          }}
                        ></Checkbox>
                      </div>
                    </Card1>
                  </Col>
                </Row>

                <Affix offsetBottom={40}>
                  {poCreationAndEditGranted(props.settings?.user) && (
                    <div className="d-flex justify-content-end">
                      <Row
                        style={{
                          backgroundColor: "white",
                          borderRadius: 8,
                          padding: 8,
                        }}
                      >
                        <Button
                          className="btn mr-2"
                          size="middle"
                          onClick={() => showModal(true)}
                          // htmlType="submit"
                        >
                          Preview
                        </Button>
                        <Button
                          className="btn mr-2"
                          size="middle"
                          onClick={() => createEstimate({ isDraft: true })}
                        >
                          Save as draft
                        </Button>
                        <Button
                          className="btn btn-primary text-white"
                          size="middle"
                          onClick={() => createEstimate({ isDraft: false })}
                        >
                          {"Create Pro Forma Invoice"}
                        </Button>
                      </Row>
                    </div>
                  )}
                </Affix>
                {/* {poCreationAndEditGranted(props.settings?.user) && (
                  <div className="d-flex justify-content-end">
                    <>
                      <Button
                        className="btn mr-2"
                        size="large"
                        onClick={() => showModal(true)}
                        // htmlType="submit"
                      >
                        Preview
                      </Button>
                      <Button
                        className="btn mr-2"
                        size="large"
                        onClick={() => createEstimate({ isDraft: true })}
                      >
                        Save as draft
                      </Button>
                      <Button
                        className="btn btn-primary text-white"
                        size="large"
                        onClick={() => createEstimate({ isDraft: false })}
                      >
                        {location.pathname.includes("edit")
                          ? "Save Changes"
                          : "Pro Forma Invoice Estimate"}
                      </Button>
                    </>
                  </div>
                )} */}
              </Form>
            </CardBody>
          </Card>
        </Spin>
      </Container>
      <Drawer
        title="Search Products"
        width={"50%"}
        onClose={() => {
          setShowProductSearchDrawer(false);
        }}
        visible={showProductSearchDrawer}
      >
        <Col className="mb-2">
          <Row justify="center">
            <Col sm={18}>
              {fileType === "csv" ? (
                <CSVReader
                  setShowProductSearchDrawer={setShowProductSearchDrawer}
                  setDataSource={setDataSource}
                  dataSource={dataSource}
                />
              ) : (
                <XLSXReader
                  setShowProductSearchDrawer={setShowProductSearchDrawer}
                  setDataSource={setDataSource}
                  dataSource={dataSource}
                />
              )}
            </Col>
            <Col sm={6}>
              {/* Switch between CSV and XLSX uploader */}
              <Radio.Group
                onChange={(e) => {
                  setFileType(e.target.value);
                }}
                value={fileType}
              >
                <Radio.Button value={"csv"}>CSV</Radio.Button>
                <Radio.Button value={"xlsx"}>XLSX</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
        </Col>
        <RateContracts
          customOnAdd={customProductAdd}
          added={dataSource.map((item) => item["boq_item"])}
          narrow
        />
      </Drawer>
      <Drawer
        title={"Add Address"}
        width={500}
        onClose={() => {
          onCloseAddress();
        }}
        visible={visibleAddress}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onCloseAddress();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="addressForm"
              type="primary"
              htmlType="submit"
              onClick={addNewAddress}
            >
              Submit
            </Button>
          </div>
        }
      >
        <Form layout="vertical" id="addressForm" ref={formRefAddress}>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"label"}
                label="Label"
                rules={[
                  {
                    required: true,
                    message: "Label is required",
                  },
                ]}
              >
                <Input placeholder="e.g. Bangalore Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"address"}
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Address is required",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 20,
                  }}
                  placeholder="e.g. Bangalore Address"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    required: true,
                    message: "Pincode is required",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={6}
                  minLength={6}
                  placeholder="Pincode"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name="contact_person"
                label="Contact Person"
                rules={[
                  {
                    required: true,
                    message: "Contact Person is required",
                  },
                ]}
              >
                <Input placeholder="Contact Person" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"contact_phone"}
                label="Contact Phone"
                rules={[
                  {
                    required: true,
                    message: "Contact Phone is required",
                  },
                ]}
              >
                <Input placeholder="Contact Phone" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"contact_email"} label="Contact Email">
                <Input placeholder="Contact Email" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name="google_map_address"
                label="Google Map Address"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL",
                  },
                ]}
              >
                <Input placeholder="Google Map Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"gst_no"} label="GST No">
                {/* After user finishes typing try to parse and set the pan no */}
                <Input
                  placeholder="GST No"
                  onBlur={(e) => {
                    const gst = e.target.value;
                    if (gst.length === 15) {
                      const pan = gst.slice(2, 12);
                      formRefAddress.current?.setFieldsValue({
                        pan_no: pan,
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"pan_no"} label="PAN No">
                <Input placeholder="PAN No" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <DeliveryDrawer
        onClose={() => setDeliveryPOCDrawerVisible(false)}
        visible={deliveryPOCDrawerVisible}
        toSendData={toSendData}
        onFinish={onDeliveryFinish}
        deliveryDetails={deliveryDetails}
      />

      <Drawer
        title="Add attachments"
        width={500}
        onClose={() => {
          setDocumentModalVisible(false);
        }}
        destroyOnClose={true}
        visible={documentModalVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                setDocumentModalVisible(false);
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="uploadForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        }
      >
        <Form
          ref={attatchmentFormRef}
          layout="vertical"
          id="uploadForm"
          // onFinish={onFileUpload}
        >
          <Form.Item>
            <Upload
              {...{ multiple: true, maxCount: 5 }}
              beforeUpload={() => false}
              onChange={({ file, fileList }) => {
                console.log(file, fileList);
                setFileInput(fileList);
              }}
              style={{ width: "100%" }}
            >
              <Button block type="dashed" icon={<UploadOutlined />}>
                Upload
              </Button>
            </Upload>
          </Form.Item>
        </Form>
      </Drawer>
      <Modal
        // style={{ width: 1000 }}
        width="70%"
        centered
        visible={isModalOpen}
        closeIcon={null}
        onCancel={() => setIsModalOpen(false)}
        okText={
          location.pathname.includes("edit")
            ? "Save Changes"
            : "Create Pro Forma Invoice"
        }
        onOk={() => {
          createEstimate({ isDraft: false });
        }}
      >
        {getPreview({
          currentGst,
          dataSource,
          additionalCharges,
          totalAdditonalCharge,
          createEstimate,
          billToDisplayAddress,
          shipToDisplayAddress,
          terms_and_conditions_description:
            finalValue?.terms_and_conditions_description,
        })}
      </Modal>
    </div>
  );
};

export default connect(mapStateToProps)(EstimateForm);
